import { ApolloLink, Observable } from '@apollo/client'

const DEDUPLICATED_LINKS = [
  'CreateAppointmentMutation',
  'CreateNoteMutation',
  'CreatePatientMutation',
  'CreateRecordingMutation',
  'CreateVoiceCommandMutation'
]
const WINDOW = 3000

const createDeduplicatedMutationLink = () => {
  const activeRequests = new Set()

  return new ApolloLink((operation, forward) => {
    const opName = operation.operationName
    const definitions = operation.query.definitions || []

    const isMutation = definitions.some(
      def => def.kind === 'OperationDefinition' && def.operation === 'mutation'
    )

    if (!isMutation || !opName || !DEDUPLICATED_LINKS.includes(opName)) {
      return forward(operation)
    }

    let key
    try {
      key = `${opName}:${JSON.stringify(operation.variables)}`
    } catch {
      return forward(operation)
    }

    if (activeRequests.has(key)) {
      return new Observable(observer => observer.complete())
    }

    activeRequests.add(key)

    return new Observable(observer => {
      const sub = forward(operation).subscribe({
        next: result => observer.next(result),
        error: error => {
          setTimeout(() => activeRequests.delete(key), WINDOW)
          observer.error(error)
        },
        complete: () => {
          setTimeout(() => activeRequests.delete(key), WINDOW)
          observer.complete()
        }
      })

      return () => {
        sub.unsubscribe()
      }
    })
  })
}

export default createDeduplicatedMutationLink
